import React, { useMemo, useState } from "react";
import { Col, Container, Row } from "react-grid-system";

import Text from "components/common/Text/Text";

import { GridRow, StyledContent, TitleRow } from "./ElementSelector.style";

interface IElement {
  id: string;
  name: string;
  checked: boolean;
}

interface IProps {
  component: JSX.Element;
  title: string;
  allElements: IElement[];
  initialSelectedIds: string[];
  onChange: (element: IElement[]) => void;
}

export default function ElementSelector({
  allElements,
  title,
  onChange,
  initialSelectedIds,
  component
}: IProps): JSX.Element {
  // Initialize the interest in local state
  const [elements, setElements] = useState(
    useSelectedElements(initialSelectedIds, allElements)
  );

  // Callback when a change is triggered, updates the local state and fires
  // onChange handler
  const onChangeCallback = (selectedElement: IElement) => {
    const selectedId = selectedElement.id;
    const newElements = (elements || []).slice();
    const elementIndex = newElements.findIndex(
      element => element.id === selectedId
    );
    newElements[elementIndex].checked = !newElements[elementIndex].checked;
    setElements(newElements);
    onChange(newElements);
  };

  return (
    <StyledContent fullWidth>
      <div
        style={{
          width: "95%",
          position: "relative",
          display: "flex",
          flexDirection: "column",
          alignItems: "center"
        }}
      >
        <TitleRow>
          <Col>
            <Text hero fullWidth center alternate>
              {title}
            </Text>
          </Col>
        </TitleRow>
        <GridRow itemsInRow={elements.length > 6 ? 6 : elements.length}>
          {React.cloneElement(component, {
            elements: elements.slice(0, 6),
            onChange: onChangeCallback
          })}
        </GridRow>
        {elements.length > 6 && (
          <GridRow itemsInRow={elements.length - 6}>
            {React.cloneElement(component, {
              elements: elements.slice(6, elements.length),
              onChange: onChangeCallback
            })}
          </GridRow>
        )}
      </div>
    </StyledContent>
  );
}

// Creates a new array with elements that are matching the status of the checked interest ids
function useSelectedElements(
  selectedIds: string[],
  elements: IElement[]
): IElement[] {
  return useMemo(
    () =>
      (elements || []).slice().map((element: any) => ({
        ...element,
        checked: selectedIds.includes(element.id)
      })),
    [selectedIds]
  );
}



// WEBPACK FOOTER //
// ./src/components/ElementSelector/ElementSelector.tsx